import axios from 'axios';
import qs from 'querystring';
import ServerProperties from '../config/server.js'
import CredentialProperties from '../config/credential.js'

import {
  CreateUserSessionProperties,
  ToogleAuthSessionProperties,
  StoreUserInformation,
  RemoveUserSessionProperties} from './action.js'

import {StoreTenantInformation} from "store/tenant/action.js"

export default {
    AuthUser: function(params){

    /**
     * THIS DONT SUPPORT ON ANY BROWSER,
     * use qs library, for this issues
     * check: https://github.com/axios/axios/issues/350#issuecomment-227270046
     */

    // var ParamsRequest = new URLSearchParams();
    // ParamsRequest.append('client_id', CredentialProperties.API_APP.id);
    // ParamsRequest.append('client_secret', CredentialProperties.API_APP.secret);
    // ParamsRequest.append('grant_type', 'password');
    // ParamsRequest.append('username', params.data.user);
    // ParamsRequest.append('password', params.data.password);

      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      axios.post(
        ServerProperties.ATM_CLOUD.API+'o/token/', qs.stringify({
          client_id     : CredentialProperties.API_APP.id,
          client_secret : CredentialProperties.API_APP.secret,
          grant_type    : 'password',
          username      : params.data.user,
          password      : params.data.password
        })
      )
      .then(function (response) {
        response.data.username = params.data.user
        params.RunRedux(CreateUserSessionProperties(response.data))
        params.model.Me(params, response.data.access_token)
    })
    .catch(error => {
      params.RunRedux(ToogleAuthSessionProperties(false))
      if(error.response !== undefined){
        params.onfailed(error.response.data)
      }
    });
  },
  Me: function(params,AuthorizationToken){
    axios.defaults.headers.common['Authorization'] = "Bearer "+AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API+'User/Me/')
    .then(function (response) {
     if(response.data.tenant && response.data.tenant.is_lite == true){
      params.onfailed({error_description:'You Login use Lite version'})
      params.RunRedux(RemoveUserSessionProperties())
     }
      else if(response.data.Active || response.data.is_superuser){
        params.RunRedux(ToogleAuthSessionProperties(false))
        params.RunRedux(StoreUserInformation(response.data)) //run redux method
        params.RunRedux(StoreTenantInformation(response.data)) //run redux method
        params.onsuccess(params.history)//direct to dashboard page

      }else{
        params.RunRedux(RemoveUserSessionProperties()) //run redux method
        params.onfailed({error_description:'You account has been disabled!'})
      }
    })
    .catch(function (error) {
      params.RunRedux(ToogleAuthSessionProperties(false))
      params.RunRedux(RemoveUserSessionProperties()) //run redux method

      if(error.response !== undefined) {
        params.onfailed(error.response.data)
      }

    });
  },
  RefreshToken: function(params){

    // var ParamsRequest = new URLSearchParams();
    // ParamsRequest.append('client_id', CredentialProperties.API_APP.id);
    // ParamsRequest.append('client_secret', CredentialProperties.API_APP.secret);
    // ParamsRequest.append('grant_type', 'refresh_token');
    // ParamsRequest.append('refresh_token', params.refresh_token);

    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    axios.post(
      ServerProperties.ATM_CLOUD.API+'o/token/', qs.stringify({
        client_id     : CredentialProperties.API_APP.id,
        client_secret : CredentialProperties.API_APP.secret,
        grant_type    : 'password',
        username      : params.data.user,
        password      : params.data.password
      })
    )
    .then(function (response) {
      response.data.username = params.UserReducer.username
      params.RunRedux(CreateUserSessionProperties(response.data)) //run redux method
      params.RunRedux(ToogleAuthSessionProperties(false))
      params.CallBack(params)
    })
    .catch(function (error) {
      params.RunRedux(ToogleAuthSessionProperties(false))
      params.onfailed(error.response)
    });
  }
}



// WEBPACK FOOTER //
// ./src/App/user/model.js